var _defs, _rect, _rect2, _rect3, _rect4, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoStaystrack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 173.58 208.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 68.68,
    y: 69.91,
    width: 14,
    height: 13
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 68.68,
    y: 89.91,
    width: 14,
    height: 13
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 90.89,
    y: 69.91,
    width: 14,
    height: 13
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 90.89,
    y: 89.91,
    width: 14,
    height: 13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.94,80.7L90.94,6.7c-2.19-2.19-5.98-2.16-8.12,0L9.84,80.7c-4.36,11.19,8.6,11.49,15.05,5.56v37.5c0,22.11,39.48,58.09,54.96,74.02,1.2,1.23,6.16,6.72,7.44,6.45,12.28-14.64,27.31-26.83,40.11-40.95,16.98-18.72,21.5-27.54,22.53-53.47l-1.05-22.54c7.48,3.87,18.61,5.14,15.05-6.57ZM89.3,154.21c-16.33,2.25-20.9-22.4-4.69-25.73,17.29-3.55,21.45,23.42,4.69,25.73ZM124.3,143.17c-.98,1.25-9.28,10.29-10.41,9.08,10.25-28.3-23.02-51.67-46.01-31.5-6.99,6.13-10.18,15.72-8.9,24.92.45,3.2,2.88,5.64,2.41,8.58-26.54-19.49-23.09-49.89-22.3-79.29l46.81-48.26c.41-.21.79-.28,1.14-.26l3.36,3.38c.28.43.56.82.84,1.09,2.18,2.06,4.33,4.16,6.48,6.28l8.28,8.34h.02c9.58,9.77,19.02,19.8,28.66,29.44-.88,23.89,5.49,48.02-10.38,68.21Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoStaystrack);
export default __webpack_public_path__ + "static/media/logo-staystrack.d2b5b1b9110f0404b834720548f7c0d3.svg";
export { ForwardRef as ReactComponent };